import { useMemo, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getProviders } from 'app/store/actions/providers/providers.actions';
import { getCredentials } from 'app/main/credentials/store/actions/credential.actions';

export default function useProviderData(providerId) {
    const dispatch = useDispatch();
    const providers = useSelector(({ providers }) => providers.providers.list);
    const allCredentials = useSelector(({ credentials }) => credentials.credential.list);

    // Auto-fetch if Redux state is empty
    useEffect(() => {
        if (!providers || providers.length === 0) {
            dispatch(getProviders());
        }
    }, [dispatch, providers]);

    useEffect(() => {
        if (!allCredentials || allCredentials.length === 0) {
            dispatch(getCredentials());
        }
    }, [dispatch, allCredentials]);

    const provider = useMemo(
        () => providers?.find((p) => p.id === providerId) || null,
        [providers, providerId]
    );

    const credentials = useMemo(
        () => (allCredentials || []).filter((c) => c.provider === providerId),
        [allCredentials, providerId]
    );

    const regions = useMemo(() => provider?.regions || [], [provider]);

    const instanceSizes = useMemo(() => provider?.instanceSizes || [], [provider]);

    const volSizeLimits = useMemo(() => provider?.volsize || { min: 100, max: 16000 }, [provider]);

    const zonesForRegion = useCallback(
        (regionId) => {
            if (!regionId || !regions.length) return [];
            const region = regions.find((r) => r.region_id === regionId);
            return region?.zones || [];
        },
        [regions]
    );

    return { credentials, regions, instanceSizes, volSizeLimits, zonesForRegion };
}
